import { SocieteService } from './../../../shared/services/simple/societe.service';
import { DetailBcLineinfos } from './../../bc/bc-components.service';
import { Title } from '@angular/platform-browser';
import { DetailBpinfos, BpComponentsService, DetailBpLineinfos } from './../bp-components.service';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { StateService } from 'src/app/shared/services/state.service';
import { BcComponentsService, DetailBcinfos } from '../../bc/bc-components.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { of } from 'rxjs/internal/observable/of';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentModel } from 'src/app/shared/models/simple-types/document.model';

@Component({
  selector: 'app-create-bp',
  templateUrl: './create-bp.component.html',
  styleUrls: ['./create-bp.component.scss']
})
export class CreateBpComponent implements OnInit {
  bpForm: UntypedFormGroup;
  bp: BpModel = new BpModel();
  user: string;
  observableBp = new BehaviorSubject<BpModel>(new BpModel());
  bcList: BcModel[];
  listOfBc: Observable<BcModel>;
  detailBpInfo: DetailBpinfos;
  bpLineHTs = 0;
  bpLineTVAs = 0;
  bpLineTTCs = 0;
  documents: DocumentModel[] = [];
  currentSociety: SocieteModel;
  DetailBpLineinfos: DetailBpLineinfos = new DetailBpLineinfos();
  selected: SelectionModel<AbstractControl> = new SelectionModel<AbstractControl>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private bpComponentsService: BpComponentsService,
    private state: StateService,
    private title: Title,
    private societeService: SocieteService,
    private bpService: BpService) {  }

  ngOnInit(): void {
    this.title.setTitle('SACHA - Créer BP');
    this.route.params.subscribe((params: any) => {
      this.bpService.get(params.id).subscribe(res => {
        this.bp = res;
        this.verifyBpStatusToRedirect(this.bp);
        this.getAndSetSociety(this.bp.idSociete).subscribe((society: SocieteModel) => {
          this.setSociety(society);
          this.state.changeSociety(this.bp.societe);
          this.bpForm = this.bpComponentsService.getCreateBpFormGroup(this.bp);
          this.bpComponentsService.loadDetailBp().subscribe((infos: DetailBpinfos) => {
            this.detailBpInfo = infos;
          });
          if (this.bpForm) {
            this.bpLineTVAs = this.bpForm.get('tva').value;
            this.bpLineTTCs = this.bpForm.get('ttc').value;
            this.bpLineHTs = this.bpForm.get('ht').value;
          }
        }, (error) => {
          this.toastrService.error('Le bon à payer n\'existe pas');
          this.router.navigate(['/not-found']);
        });
      });
    });
  }

  print(): void {
  }

  close(): void {
    this.router.navigate(['/']);
  }

  setValuesToBp(): void {
    this.bp = this.bpForm.getRawValue();
    this.bp.bpLines = (this.bpForm.get('bpLines') as UntypedFormArray).getRawValue();
    this.bp.idSociete = this.currentSociety.id;
    this.bp.societe = this.currentSociety;
    this.bp.code = this.bpForm.controls.code.value;
    this.bp.libelle = this.bpForm.controls.libelle.value;
    this.bp.tva = this.bpLineTVAs;
    this.bp.ht = this.bpLineHTs;
    this.bp.ttc = this.bpLineTTCs;
    if (this.selected) {
      this.selected.selected.forEach(row => {
        const line = this.bp.bpLines.find(bpline => bpline.id === row.get('id').value);
        if (line) {
          this.bp.bpLines.find(bpline => bpline.id === row.get('id').value).bAnnule = true;
          // tslint:disable-next-line: max-line-length
          (this.bpForm.get('bpLines') as UntypedFormArray).controls.find(bpline => bpline.get('id').value === row.get('id').value).get('bAnnule').setValue(true);
        }
      });
    }
  }

  getSelectedDocuments(object: any): void {
    this.documents = object;
  }

  memorize(): void {
    this.setValuesToBp();
    const dialogRef = this.dialog.open(SpinnerModalComponent);
    this.bpComponentsService.memorizeBp(this.bp).subscribe((data: any) => {
      dialogRef.close();
      this.bp = data;
    }, (error) => dialogRef.close());
  }

  /**
   * Refuser l'envoi en validation si Total HT des lignes sans lignes BC > 1000€ ou > 5% du total HT du BP Front
   */

  validateTotalHtLines(): boolean {
    for (const line of this.bp.bpLines) {
      if (!line.idBcLigne && (line.ht > 1000 || line.ht > (this.bp.ht * 0.05)) && !line.bAnnule) {
        return false;
      }
    }
    return true;
  }

  displayErrors(): void {
    for (const bc in this.bpForm.controls) {
      if (bc) {
        this.bpForm.controls[bc].markAsTouched();
      }
    }
  }

  validate(): void {
    if (this.bpLineTTCs !== this.bpForm.get('montantFacture').value) {
      this.bpForm.get('montantFacture').setErrors({ different : true});
    }
    if (this.documents.length > 0) {
      if (this.bpForm.valid) {
          this.setValuesToBp();
          if (this.validateTotalHtLines()) {
            const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.bpComponentsService.saveBp(this.bp).subscribe((res) => {
              if (res) {
                dialogRef.close();
                const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
                  data: {
                    title: 'Voulez-vous créer un autre BP ?',
                    message: '',
                    color: 'primary'
                  }
                });
                return dialogConfirmation.afterClosed().subscribe((res) => {
                  if (res) {
                    localStorage.setItem('societe', JSON.stringify(this.currentSociety));
                    this.router.navigate(['/select-bc-for-create-bp']);
                  } else {
                    dialogRef.close();
                    this.close();
                  }
                });
              }
            }, (error) => dialogRef.close());
          } else {
            this.toastrService.warning('Une de vos lignes BP sans BC dépasse le seuil autorisé.');
          }
        }
      this.displayErrors();
      const formArray: UntypedFormArray = this.bpForm.get('bpLines') as UntypedFormArray;
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < formArray.controls.length; i++) {
        for (const bcLineControl in (formArray.controls[i] as UntypedFormGroup).controls) {
          if ((formArray.controls[i] as UntypedFormGroup).controls[bcLineControl].errors) {
            this.toastrService.warning('Veuillez remplir le champ : ' + bcLineControl);
          }
        }
      }
    } else {
      this.toastrService.warning('Veuillez Ajouter au moins un document');
    }
  }

  setSociety(society: SocieteModel): void {
    if (society) {
      this.currentSociety = Object.assign({}, society);
      this.bp.societe = this.currentSociety;
    }
  }

  getAndSetSociety(idSociety: number): Observable<SocieteModel> {
    return this.societeService.get(idSociety);
  }

  changeAnnule(selected: SelectionModel<AbstractControl>): void {
    this.selected = selected;
  }

  calculateHorsTaxes(object: any): void {
    if (this.getHtAMount(object) !== undefined) {
      this.bpLineHTs = Math.round(this.getHtAMount(object) * 100) / 100;
    }
  }

  calculateTvas(object: any): void {
    if (this.getTvaAMount(object) !== undefined) {
      this.bpLineTVAs = Math.round(this.getTvaAMount(object) * 100) / 100;
    }
  }

  calculateTtcs(object: any): void {
    if (this.getTtcAMount(object) !== undefined) {
      this.bpLineTTCs = Math.round(this.getTtcAMount(object) * 100) / 100;
    }
  }

  getHtAMount(object: any): number {
    // tslint:disable-next-line
    let amountsHt = [];
    let amountHtTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountHtValue = 0;
      if (object[obj].amount !== undefined) {
        amountHtValue = amountHtValue + object[obj].amount;
        amountsHt.push(amountHtValue);
        if (obj === object.length - 1) {
          for (const amount of amountsHt) {
            amountHtTotal += amount;
          }
          return amountHtTotal;
        }
      }
    }
  }

  getTvaAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTva = [];
    let amountTvaTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTvaValue = 0;
      if (object[obj].amount !== undefined) {
        amountTvaValue = amountTvaValue + object[obj].amount;
        amountsTva.push(amountTvaValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTva) {
            amountTvaTotal += amount;
          }
          return amountTvaTotal;
        }
      }
    }
  }

  getTtcAMount(object: any): number {
    // tslint:disable-next-line
    let amountsTtc = [];
    let amountTtcTotal = 0;
    for (let obj = 0; obj < object.length; obj++) {
      let amountTtcValue = 0;
      if (object[obj].amount !== undefined) {
        amountTtcValue = amountTtcValue + object[obj].amount;
        amountsTtc.push(amountTtcValue);
        if (obj === object.length - 1) {
          for (const amount of amountsTtc) {
            amountTtcTotal += amount;
          }
          return amountTtcTotal;
        }
      }
    }
  }

  verifyBpStatusToRedirect(bp: BpModel): void {
    if (bp) {
      if (bp.status !== 'Brouillon') {
        this.router.navigate(['/']);
        this.toastrService.warning('Ce bon à payer a déjà été envoyé en validation.', 'Erreur');
      }
    }
  }
}
